// Compose form schemas using field validators (keys = form input names).
import * as Yup from "yup";
import fields from "./fields";

// Employee schema (AddEmployee)
export const employeeSchema = Yup.object().shape({
  firstName: fields.nameField("First name is required"),
  dob: fields.requiredString("Dob is required"),
  gender: fields.requiredString("Gender is required"),
  address1: fields.requiredString("Address 1 is required"),
  email: fields.emailField("Email is required"),
  mobile: fields.mobileField("Mobile is required"),
  pan: fields.panField(),
  aadhar: fields.aadharField(),
});

// Role Privilege schema (AddRolePrivilege)
export const rolePrivilegeSchema = Yup.object().shape({
  roleName: fields.requiredString("Role Name is required"),
  menuName: fields.requiredString("Menu Name is required"),
  view: Yup.boolean().notRequired(),
  add: Yup.boolean().notRequired(),
  edit: Yup.boolean().notRequired(),
  delete: Yup.boolean().notRequired(),
});

// Role schema (AddRole)
export const roleSchema = Yup.object().shape({
  roleName: fields.requiredString("Role name is required")
    .min(2, "Role name must be at least 2 characters")
    .max(50, "Role name must not exceed 50 characters"),
  roleDescription: fields.requiredString("Role description is required")
    .min(10, "Role description must be at least 10 characters")
    .max(200, "Role description must not exceed 200 characters"),
});

// Theme Master schema (ThemeMaster)
export const themeMasterSchema = Yup.object().shape({
  report_title: fields.requiredString("Report Title / Company Name is required."),
  subtitle: Yup.string().nullable(),
  address: fields.requiredString("Address is required."),
  landmark: Yup.string().nullable(),
  pin_code: fields.pinField(),
  mobile: fields.mobileField("Mobile is required."),
  email: fields.emailField("Email is required."),
  website: fields.websiteField(),
  logo_align: fields.enumField(["Left", "Right", "None"], "Invalid alignment"),
});

export const commonFieldsSchema = Yup.object().shape({
  address: fields.requiredString("Address is required."),
  pin_code: fields.pinField(),
  mobile: fields.mobileField("Mobile is required."),
  email: fields.emailField("Email is required."),
  pan: Yup.string().matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN format').required('PAN is required'),
  aadhar: Yup.string().matches(/^[0-9]{12}$/, 'Aadhar must be 12 digits').required('Aadhar is required'),

});

// Export all schemas in one map
export const SCHEMAS = {
  employee: employeeSchema,
  rolePrivilege: rolePrivilegeSchema,
  role: roleSchema,
  themeMaster: themeMasterSchema,
  commonFields: commonFieldsSchema
};

export default SCHEMAS;
